// extracted by mini-css-extract-plugin
export default {"list":"style_list__0ZTDX"};